<template>
  <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.1996 4.38397C22.6049 4.38397 27.8092 9.5867 27.8092 15.9948C27.8092 22.4028 22.6049 27.6059 16.1996 27.6059C9.7809 27.6059 4.5899 22.4028 4.5899 15.9948C4.5899 9.5867 9.7809 4.38397 16.1996 4.38397ZM18.3213 19.5845C19.0019 19.3376 19.5357 18.7985 19.7892 18.1153C20.4831 16.1763 21.951 12.125 22.6449 10.2106C22.7117 10.0207 22.6716 9.80823 22.5248 9.66544C22.3781 9.52279 22.1645 9.47542 21.9777 9.54414C20.0695 10.2371 16.0128 11.7033 14.0778 12.4052C13.3972 12.6534 12.8501 13.1912 12.6099 13.8744C11.9027 15.8134 10.4348 19.8647 9.74086 21.7797C9.67414 21.9692 9.72752 22.1813 9.86096 22.3241C10.0078 22.4669 10.2213 22.5149 10.4081 22.4456C12.3297 21.753 16.3731 20.2864 18.3213 19.5845ZM16.1996 13.7063C17.454 13.7063 18.4815 14.7325 18.4815 15.9948C18.4815 17.2572 17.454 18.2834 16.1996 18.2834C14.9319 18.2834 13.9043 17.2572 13.9043 15.9948C13.9043 14.7325 14.9319 13.7063 16.1996 13.7063Z"
      fill="#3CA091"
    />
  </svg>
</template>

<script>
export default {
  name: 'CompassVariableColorSelected'
};
</script>

<style scoped>
svg circle {
  fill: currentColor;
}
</style>
